import { syncLicenses } from "src/store/data/actions";

const routes = [
  {
    path: "/",
    component: () => import("layouts/AppLayout"),
    children: [
      { path: "/activity-checklist", name: "activity-checklist", component: () => import("pages/ActivityChecklist.vue"), meta: { hide_top_search: true, hide_top_licenses: true } },
      { path: "/activity-checklist/periods/:period([0-9]+)", name: "activity-checklist-period", component: () => import("pages/ActivityChecklist.vue"), meta: { hide_top_search: true, hide_top_licenses: true } },
      // Browsing Listings
      {
        path: "/",
        name: "auctions-browse",
        component: () => import("pages/AuctionsBrowse"),
        redirect: "/marketplace",
        children: [
          {
            path: "/auctions/:id([0-9]+)",
            props: (route) => ({
              id: route.params.id,
              isAuction: true,
            }),
            name: "auctions-view",
            component: () => import("pages/AuctionListingPage"),
            meta: {
              hide_top_search: true,
            },
          },
          {
            path: "/auctions/:id([0-9]+)/pay",
            props: true,
            name: "auctions-pay",
            component: () => import("pages/AuctionsCheckout"),
            meta: {
              hide_top_search: true,
            },
          },
          {
            path: "/logout",
            name: "logout-dialog",
            component: () => import("pages/AppLogout"),
          },
        ],
      },

      {
        path: "/marketplace",
        name: "marketplace",
        component: () => import("pages/Marketplace.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("pages/Dashboard.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },
      {
        path: "/ai-agents",
        name: "ai-agents",
        component: () => import("pages/AiAgents.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          requiresAiAgents: true,
        },
      },
      {
        path: "/marketplace/brands",
        name: "marketplace-brands",
        component: () => import("pages/MarketplaceBrands.vue"),
        meta: {
          //hide_top_search: true,
          //hide_top_licenses: true
        },
      },
      {
        path: "/marketplace/new",
        name: "marketplace-new",
        component: () => import("pages/MarketplaceNew.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },
      {
        path: "/marketplace/listings",
        name: "marketplace-listings",
        component: () => import("pages/MarketplaceListings.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },
      {
        path: "/marketplace/auctions",
        name: "marketplace-auctions",
        component: () => import("pages/MarketplaceAuctions.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },
      {
        path: "/marketplace/wanted",
        name: "marketplace-wanted",
        component: () => import("pages/Marketplace.vue"),
      },
      {
        path: "/marketplace/external/products",
        name: "marketplace-external-products",
        component: () => import("pages/ExternalVendorProductsUniqueBrowse.vue"),
      },
      {
        path: "/auctions/:categoryType",
        name: "auctions-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/auctions/:categoryType/:category",
        name: "auctions-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },

      // Featured Listings
      {
        path: "/featured",
        name: "featured-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/featured/:categoryType",
        name: "featured-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/featured/:categoryType/:category",
        name: "featured-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },

      // Listings Ending Soon
      {
        path: "/ending-soon",
        name: "ending-soon-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/ending-soon/:categoryType",
        name: "ending-soon-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/ending-soon/:categoryType/:category",
        name: "ending-soon-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },

      // Buy it Now Listings
      {
        path: "/buy-it-now",
        name: "buy-it-now-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/buy-it-now/:categoryType",
        name: "buy-it-now-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/buy-it-now/:categoryType/:category",
        name: "buy-it-now-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },

      // Watched Listings
      {
        path: "/watched",
        name: "watched-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/followed-brands",
        name: "followed-brands-browse",
        component: () => import("pages/FollowedBrands"),
      },
      {
        path: "/watched/active-bids",
        name: "watched-active-bids",
        component: () => import("pages/ActiveBids"),
      },
      {
        path: "/watched/active-bids/:categoryType",
        name: "watched-active-bids-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/watched/active-bids/:categoryType/:category",
        name: "watched-active-bids-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/watched/:categoryType",
        name: "watched-type-browse",
        component: () => import("pages/AuctionsBrowse"),
      },
      {
        path: "/watched/:categoryType/:category",
        name: "watched-category-browse",
        component: () => import("pages/AuctionsBrowse"),
      },

      //Product Listings
      {
        path: "/product-listings/:id",
        name: "product-listings",
        component: () => import("pages/AuctionsByProduct.vue"),
        props: true,
      },
      // Purchase order listings
      {
        path: "/external-vendor-products/:id",
        name: "external-vendor-product-listings",
        component: () => import("pages/ExternalVendorProductPage.vue"),
        props: true,
      },

      // Watching Listings
      {
        path: "/my/watchlist",
        name: "my-watchlist",
        component: () => import("pages/MyWatchlist"),
      },
      //Active Bids
      {
        path: "/my/active-bids",
        name: "active-bids",
        component: () => import("pages/ActiveBids"),
      },

      // Brand
      {
        path: "/brands",
        name: "brands-browse",
        component: () => import("pages/BrandsPage"),
      },
      {
        path: "/brands/:brandId",
        name: "brand-listings",
        component: () => import("pages/BrandStorefront"),
        props: true,
      },
      {
        path: "/brands/:brandId/generic-orders/new",
        name: "generic-order-entry",
        component: () => import("pages/GenericOrderEntry"),
        props: true,
      },
      {
        path: "/brands/company-:brandId",
        name: "company-brand-listings",
        component: () => import("pages/CompanyStorefront"),
        props: true,
      },

      /*
      // My History
      {
        path: "/my/history",
        name: "my-history",
        component: () => import("pages/MyHistory"),
      },
      {
        path: "/my/history/sales/:id",
        name: "my-history-sale",
        component: () => import("pages/MyHistorySale"),
        props: true,
      },
      {
        path: "/my/history/sales/:id/pay",
        name: "my-history-sale-fee-pay",
        component: () => import("pages/MyHistoryFeePay"),
        props: true,
      },
      {
        path: "/my/history/sales/:id/packages",
        name: "my-history-sale-packages",
        component: () => import("pages/MyHistorySalePackages"),
        props: true,
      },
      {
        path: "/my/history/sales/:id/shipping-boxes",
        name: "my-history-sale-shipping-boxes",
        component: () => import("pages/MyHistorySaleShippingBoxes"),
        props: true,
      },
      {
        path: "/my/history/sales/:id/review",
        name: "my-history-sale-review",
        component: () => import("pages/MyHistoryReview"),
        props: true,
      },
      {
        path: "/my/history/purchases/:id",
        name: "my-history-purchase",
        component: () => import("pages/MyHistoryPurchase"),
        props: true,
      },
      {
        path: "/my/history/purchases/:id/pay",
        name: "my-history-purchase-fee-pay",
        component: () => import("pages/MyHistoryFeePay"),
        props: true,
      },
      {
        path: "/my/history/purchases/:id/review",
        name: "my-history-purchase-review",
        component: () => import("pages/MyHistoryReview"),
        props: true,
      },
      */

      // My Company — Account & Settings
      //
      // All of the former standalone hub pages/routes below now live as
      // tabs inside CommsSettingsHub.vue (comms-settings-hub). The old
      // names/paths are kept as redirects (rather than deleted) because
      // they're still referenced by name from elsewhere in the app
      // (AppHeader, AppMenu, IntegrationSettings, MyOrderIncomingView,
      // MyInventoryReorder, MyCompanyFacilities's own Metrc gate, etc.).
      {
        path: "/my/company/settings",
        name: "comms-settings-hub",
        component: () => import("pages/CommsSettingsHub.vue"),
      },
      {
        path: "/my/company/profile",
        name: "my-company-profile-hub",
        redirect: { name: "comms-settings-hub", query: { tab: "profile" } },
      },
      {
        path: "/my/company/profile/user",
        name: "my-company-user-profile",
        redirect: { name: "comms-settings-hub", query: { tab: "profile" } },
      },
      {
        path: "/my/company/profile/account",
        name: "my-company-account-profile",
        redirect: { name: "comms-settings-hub", query: { tab: "company" } },
      },
      {
        path: "/my/company/profile/notifications",
        name: "my-company-notifications-profile",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "notifications" },
        },
      },
      {
        path: "/my/company/profile/api-keys",
        name: "my-company-api-keys-profile",
        redirect: { name: "comms-settings-hub", query: { tab: "api-keys" } },
      },
      {
        path: "/my/company/buyer-agreement",
        name: "my-company-buyer-agreement",
        redirect: { name: "comms-settings-hub", query: { tab: "agreements" } },
      },
      {
        path: "/my/company/billing",
        name: "my-company-billing-hub",
        redirect: { name: "comms-settings-hub", query: { tab: "billing" } },
      },
      {
        path: "/my/company/team",
        name: "my-company-team-hub",
        redirect: { name: "comms-settings-hub", query: { tab: "users" } },
      },
      {
        path: "/my/company/operations",
        name: "my-company-operations-hub",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "invoice-transport" },
        },
      },
      {
        path: "/my/company/facilities",
        name: "my-company-facilities",
        redirect: { name: "comms-settings-hub", query: { tab: "facilities" } },
      },
      {
        path: "/my/company/transport",
        name: "my-company-transport",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "invoice-transport" },
        },
      },
      {
        path: "/my/company/subscriptions",
        name: "my-company-subscriptions",
        component: () => import("pages/MyCompanySubscriptions"),
      },
      {
        path: "/my/company/payment-methods",
        name: "my-company-payment-methods",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "billing", billingTab: "payment-methods" },
        },
      },
      {
        path: "/my/company/pricing-plans",
        name: "my-company-pricing-plans",
        component: () => import("pages/PricingPlansContainer.vue"),
        meta: {
          permissions: ["see_pricing_plans"],
        },
      },
      {
        path: "/my/company/invoice-settings",
        name: "my-company-invoice-settings",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "invoice-transport" },
        },
      },
      {
        path: "/my/company/billing-history",
        name: "my-company-billing-history",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "billing", billingTab: "billing-history" },
        },
      },
      {
        path: "my/company/integrations",
        name: "my-company-integrations",
        redirect: {
          name: "comms-settings-hub",
          query: { tab: "integrations" },
        },
      },
      {
        path: "my/company/integrations/:integrationId/settings",
        name: "integration-settings",
        props: true,
        component: () => import("pages/IntegrationSettings.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/map-customers",
        name: "integration-map-customers",
        props: true,
        component: () => import("pages/CustomerMappingPage.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/map-products",
        name: "integration-map-products",
        props: true,
        component: () => import("pages/ProductMappingPage.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/woocommerce/products",
        name: "integration-woocommerce-products",
        props: true,
        component: () => import("pages/WooCommerceProductsImport.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/shopify/products",
        name: "integration-shopify-products",
        props: true,
        component: () => import("pages/WooCommerceProductsImport.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/map-custom-fields",
        name: "integration-map-custom-fields",
        props: true,
        component: () => import("pages/CustomFieldMappingPage.vue"),
      },
      {
        path: "my/company/integrations/:integrationId/logs",
        name: "integration-logs",
        props: true,
        component: () => import("pages/IntegrationLogs.vue"),
      },
      {
        path: "/my/company/reports",
        name: "my-company-reports",
        component: () => import("pages/MyCompanyReports"),
      },
      {
        path: "/my/company/logo",
        name: "my-company-logo-edit",
        component: () => import("pages/MyCompanyLogo"),
      },
      {
        path: "/my/company/licenses/:id",
        props: true,
        name: "my-company-license-edit",
        component: () => import("pages/MyCompanyLicenseEdit"),
      },
      {
        path: "/my/company/payment-methods/:id([0-9]+)",
        props: true,
        name: "my-company-payment-method-edit",
        component: () => import("pages/MyCompanyPaymentMethodEdit"),
      },
      {
        path: "/my/company/users/:id",
        props: true,
        name: "my-company-users-edit",
        component: () => import("pages/MyCompanyUserEdit"),
      },
      {
        path: "/my/company/buyer-dashboard",
        props: true,
        name: "my-company-buyer-dashboard",
        component: () => import("pages/DashboardBuyer.vue"),
      },
      {
        path: "/my/company/vendor-dashboard",
        props: true,
        name: "my-company-vendor-dashboard",
        component: () => import("pages/DashboardVendor.vue"),
      },
      {
        path: "/my/company/race-charts",
        name: "my-company-race-charts",
        component: () => import("pages/RaceChartsDashboard.vue"),
      },
      {
        path: "/my/company/race-charts/:viewName",
        props: true,
        name: "my-company-race-chart",
        component: () => import("pages/RaceChartPage.vue"),
      },
      {
        path: "/my/contacts/:id",
        name: "contact-details",
        component: () => import("pages/ContactDetails.vue"),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      // My Contacts
      {
        path: "/my/contacts",
        name: "my-contacts",
        component: () => import("pages/MyCompanyYourContacts.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // Shipping Portal
      {
        path: "/my/transfers",
        name: "my-transfers",
        component: () => import("pages/MyTransfers"),
      },
      {
        path: "/my/transfer/:id",
        name: "my-transfer",
        props: true,
        component: () => import("pages/MyTransfer"),
      },
      {
        path: "/my/transfers/new",
        name: "my-transfers-new",
        component: () => import("pages/TransferPageContainer"),
      },
      {
        path: "/my/transfers/:id/edit",
        props: true,
        name: "my-transfer-edit",
        component: () => import("pages/MyTransferEdit"),
      },
      {
        path: "/transferHeader",
        props: true,
        name: "transfer-header",
        component: () => import("pages/TransferHeader"),
      },
      {
        path: "/transferFinalize",
        props: true,
        name: "transfer-finalize",
        component: () => import("pages/TransferFinalize"),
      },
      {
        path: "/transferPage",
        name: "transfer-page",
        component: () => import("pages/TransferPageContainer"),
      },
      {
        path: "/packageWholesale",
        name: "package-wholesale",
        component: () => import("pages/PackageWholesale"),
        props: true,
      },
      {
        path: "/packageTagCreate",
        name: "package-tag-create",
        component: () => import("components/NewPackageItem"),
        props: true,
      },
      {
        path: "/bulkPackagesCreate",
        name: "bulk-packages-create",
        component: () => import("pages/BulkPackagesCreate"),
        props: true,
      },
      // checkout
      {
        path: "/checkout",
        name: "checkout",
        component: () => import("pages/CheckoutPage"),
      },

      // My Brands
      {
        path: "/my/brands",
        name: "my-brands",
        component: () => import("pages/MyBrands"),
        meta: {
          permissions: ["read_brands"],
        },
      },
      {
        path: "/my/brands/:id",
        props: true,
        name: "my-brands-edit",
        component: () => import("pages/MyBrandsEdit"),
        meta: {
          permissions: ["update_brands"],
        },
      },
      {
        path: "/my/brands/:brandId([0-9]+)/preview",
        name: "my-brands-preview",
        component: () => import("pages/PublicBrandPage.vue"),
        props: (route) => ({
          brandId: Number(route.params.brandId),
          is_company_storefront: false,
          previewMode: true,
        }),
      },
      {
        path: "/my/brands/new",
        name: "my-brands-new",
        component: () => import("pages/MyBrandsEdit"),
        meta: {
          permissions: ["create_brands"],
        },
      },
      {
        path: "/my/brands/consolidated",
        name: "my-brands-consolidated",
        component: () => import("pages/MyBrandsEdit"),
        props: {
          isConsolidated: true,
        },
      },
      {
        path: "/my/brands/company-:companyId([0-9]+)/preview",
        name: "my-company-storefront-preview",
        component: () => import("pages/PublicBrandPage.vue"),
        props: (route) => ({
          brandId: Number(route.params.companyId),
          is_company_storefront: true,
          previewMode: true,
        }),
      },
      {
        path: "/my/brands/consolidated",
        name: "my-brands-consolidated",
        component: () => import("pages/MyBrandsEdit"),
        props: {
          isConsolidated: true,
        },
      },
      {
        path: "/my/products/:id([0-9]+)?",
        name: "my-product",
        redirect: (to) => {
          if (to.params.id) {
            return {
              name: "my-product-v2",
              params: {id: to.params.id},
              query: to.query,
              hash: to.hash,
            };
          }

          return {
            name: "my-product-add-v2",
            query: to.query,
            hash: to.hash,
          };
        },
      },
      {
        path: "/my/products/new",
        name: "my-product-add",
        redirect: (to) => ({
          name: "my-product-add-v2",
          query: to.query,
          hash: to.hash,
        }),
      },
      {
        path: "/bulk-edit",
        name: "bulk-inventory-edit",
        component: () => import("pages/BulkInventoryEdit"),
        props: true,
      },
      {
        path: "/my/product-lines",
        name: "my-product-lines",
        component: () => import("pages/ProductLinesPage"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/my/product-lines/new",
        name: "my-product-lines-new",
        component: () => import("components/MyBrands/ProductLineForm"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/my/product-lines/:id/edit",
        name: "my-product-lines-edit",
        component: () => import("components/MyBrands/ProductLineForm"),
        meta: {
          requiresAuth: true,
        },
      },
      // My Inventory
      {
        path: "/my/inventory",
        name: "my-inventory",
        component: () => import("pages/MyInventoryWrapper"),
        meta: {
          supports_all_licenses: true,
          permissions: ["view_inventory"],
        },
      },
      {
        path: "/my/inventory/products",
        name: "my-inventory-products",
        component: () => import("pages/MyInventoryProducts"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
          permissions: ["view_inventory"],
        },
      },
      {
        path: "/my/inventory/buckets",
        name: "my-inventory-buckets",
        component: () => import("pages/InventoryBucketsPage"),
      },
      {
        path: "/my/inventory/buckets/reorder",
        name: "my-inventory-bucket-reorder",
        component: () =>
          import("pages/MyInventoryBucketReorder.vue"),
      },
      {
        path: "/my/inventory/buckets/:id",
        name: "my-inventory-buckets-show",
        component: () => import("pages/InventoryBucketViewPage"),
        props: true,
      },
      {
        path: "/my/inventory/package-management",
        name: "my-package-management",
        component: () => import("pages/MyPackageManagement"),
        meta: {
          supports_all_licenses: true,
        },
      },
      // Disabling this route as retailer's inventory will appear in OrderPro page component under Inventory Wrapper
      // {
      //   path: "/my/inventory/retailer",
      //   name: "my-inventory-retailer",
      //   component: () => import("pages/MyInventoryRetailer"),
      //   meta: {
      //     supports_all_licenses: true, //"All Licenses" selection will be available on a page.
      //   },
      // },
      {
        path: "/my/inventory/price-groups",
        name: "my-inventory-price-groups",
        component: () => import("pages/MyInventoryPriceGroups"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/bulk-discounts",
        name: "my-inventory-bulk-discounts",
        component: () => import("pages/MyInventoryBulkDiscounts"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/promo-groups",
        name: "my-inventory-promo-groups",
        component: () => import("pages/MyInventoryPromoGroups"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/terms-groups",
        name: "my-inventory-terms-groups",
        component: () => import("pages/MyInventoryPaymentTermsGroups"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/product-tags",
        name: "my-inventory-product-tags",
        component: () => import("pages/MyInventoryProductTagsManager.vue"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/custom-menus",
        name: "my-inventory-custom-menus",
        component: () => import("pages/MyInventoryCustomMenus.vue"),
        meta: {
          supports_all_licenses: true, //"All Licenses" selection will be available on a page.
        },
      },
      {
        path: "/my/inventory/reorder",
        name: "my-inventory-reorder",
        component: () => import("pages/MyInventoryReorder.vue"),
      },
      {
        path: "/my/inventory/reorders",
        name: "my-inventory-reorders",
        component: () => import("pages/MyInventoryReorders.vue"),
      },
      {
        path: "/my/inventory/reorders/group/:id([0-9]+)",
        name: "my-inventory-reorder-group",
        props: true,
        component: () => import("pages/MyInventoryReorderGroup.vue"),
      },
      {
        path: "/my/inventory/reorders/group/:id([0-9]+)",
        name: "my-inventory-reorder-group",
        props: true,
        component: () => import("pages/MyInventoryReorderGroup.vue"),
      },
      {
        path: "/my/inventory/reorders/group/:id([0-9]+)/reject",
        name: "my-inventory-reorder-group-reject",
        props: true,
        component: () => import("pages/MyInventoryReorderGroupReject.vue"),
      },
      {
        path: "/my/inventory/reorders/group/:id([0-9]+)/accept",
        name: "my-inventory-reorder-group-accept",
        props: true,
        component: () => import("pages/MyInventoryReorderGroupAccept.vue"),
      },

      {
        path: "/my/inventory/from-sharing",
        name: "my-inventory-from-sharing",
        props: true,
        component: () => import("pages/MyInventoryFromSharing.vue"),
      },

      {
        path: "/my/v2/inventory/products/add",
        name: "my-product-add-v2",
        component: () => import("pages/MyProductAddV2.vue"),
      },
      {
        path: "/my/v2/inventory/products/:id([0-9]+)",
        name: "my-product-v2",
        component: () => import("pages/MyProductV2.vue"),
        props: true,
      },

      // My Listings
      {
        path: "/my/inventory/listings",
        name: "my-listings",
        component: () => import("pages/MyListings"),
        meta: {
          supports_all_licenses: true,
        },
      },
      {
        path: "/my/listings/add",
        name: "my-listing-add",
        component: () => import("pages/MyListingAdd"),
      },
      {
        path: "/my/listings/:id([0-9]+)",
        props: true,
        name: "my-listing",
        component: () => import("pages/MyListing"),
      },
      {
        path: "/my/listings/draft/:id([0-9]+)",
        props: true,
        name: "my-listing-draft",
        component: () => import("pages/MyListingDraft"),
      },
      {
        path: "/my/listings/:id(D?[0-9]+)/edit",
        props: true,
        name: "my-listing-edit",
        component: () => import("pages/MyListingEdit"),
      },
      {
        path: "/my/listings/:id(D?[0-9]+)/preview",
        props: true,
        name: "my-listings-preview",
        component: () => import("pages/AuctionsView"),
      },

      {
        path: "/my/avatar",
        name: "my-avatar-edit",
        component: () => import("pages/MyAvatar"),
      },

      // My Production
      {
        path: "/my/production",
        name: "my-production",
        component: () => import("pages/MyProduction"),
      },

      // Mobile Pages
      {
        path: "/mobile/search",
        name: "mobile-search",
        component: () => import("pages/MobileSearch"),
      },
      {
        path: "/mobile/new",
        name: "mobile-add-new",
        component: () => import("pages/MobileMenuAddNew"),
      },

      //Buyer Requests
      {
        path: "/wanted",
        name: "buyer-requests",
        component: () => import("pages/BuyerRequests"),
      },
      {
        path: "/wanted/:categoryType",
        props: true,
        name: "buyer-requests-category-type",
        component: () => import("pages/BuyerRequests"),
      },
      {
        path: "/wanted/:categoryType/:category",
        props: true,
        name: "buyer-requests-category",
        component: () => import("pages/BuyerRequests"),
      },
      {
        path: "/wanted/new",
        name: "new-buyer-request",
        component: () => import("pages/BuyerRequestsAdd"),
      },
      {
        path: "/wanted/:id([0-9]+)",
        props: true,
        name: "view-buyer-request",
        component: () => import("pages/BuyerRequestsView"),
      },
      {
        path: "/wanted/:id([0-9]+)/make-offer",
        props: true,
        name: "add-buyer-request-offer",
        component: () => import("pages/BuyerRequestsOffersAdd"),
      },
      {
        path: "/wanted/:id([0-9]+)/offers",
        props: true,
        name: "buyer-request-offers",
        component: () => import("pages/BuyerRequestsOffers"),
      },
      {
        path: "/wanted/:id([0-9]+)/offers/:offerId([0-9]+)",
        props: true,
        name: "view-buyer-request-offer",
        component: () => import("pages/BuyerRequestsOffersView"),
      },
      {
        path: "/wanted/:id([0-9]+)/offers/:offerId([0-9]+)/accept",
        props: true,
        name: "accept-buyer-request-offer",
        component: () => import("pages/BuyerRequestsOffersAccept"),
      },
      // Quicksight Demo
      {
        path: "/quicksight",
        name: "quicksight",
        component: () => import("pages/QuickSightDemo"),
      },
      {
        path: "/quicksight-ask",
        name: "quicksight-ask",
        component: () => import("pages/AskQDemo"),
      },

      //Inventory Listings
      {
        path: "inventory-listings/:id([0-9]+)",
        props: (route) => ({
          id: route.params.id,
          isAuction: false,
        }),
        name: "view-inventory-listing",
        component: () => import("pages/InventoryListingPage"),
        meta: {
          hide_top_search: true,
        },
      },
      {
        path: "inventory-listings/:id([0-9]+)/order",
        props: true,
        name: "inventory-listing-order",
        component: () => import("pages/InventoryListingsPlaceOrder.vue"),
        meta: {
          hide_top_search: true,
        },
      },
      {
        path: "inventory-listings/:id([0-9]+)/make-offer",
        props: true,
        name: "add-inventory-listing-offer",
        component: () => import("pages/InventoryListingsOffersAdd.vue"),
      },
      {
        path: "inventory-listings/:id([0-9]+)/offers",
        props: true,
        name: "inventory-listing-offers",
        component: () => import("pages/InventoryListingsOffers.vue"),
      },
      {
        path: "/inventory-listings/:id([0-9]+)/offers/:offerId([0-9]+)",
        props: true,
        name: "view-inventory-listing-offer",
        component: () => import("pages/InventoryListingsOffersView"),
      },
      {
        path: "/inventory-listings/:id([0-9]+)/offers/:offerId([0-9]+)/accept",
        props: true,
        name: "accept-inventory-listing-offer",
        component: () => import("pages/InventoryListingsOffersAccept"),
      },

      //Orders pages
      {
        path: "my/orders/incoming",
        props: true,
        name: "my-incoming-orders",
        component: () => import("pages/MyOrdersIncoming.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "/my/orders/incoming/generic-orders",
        props: { sellerView: true },
        name: "incoming-generic-orders",
        component: () => import("pages/GenericOrdersList.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "/my/orders/incoming/generic-orders/:id([0-9]+)",
        props: (route) => ({ id: route.params.id }),
        name: "view-incoming-generic-order",
        component: () => import("pages/GenericOrderSellerWorkspace.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/custom-quotes",
        props: { customQuotes: true },
        name: "my-custom-quotes",
        component: () => import("pages/MyOrdersIncoming.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/affiliated-transfers",
        props: true,
        name: "my-affiliated-transfers",
        component: () => import("pages/MyAffiliatedTransfers.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/affiliated-transfers/manual/:draftId([0-9]+)?",
        props: true,
        name: "manual-affiliated-transfer",
        component: () => import("pages/MyAffiliatedTransferManualAdd.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/affiliated-transfers/:id([0-9]+)",
        props: true,
        name: "view-affiliated-transfer",
        component: () => import("pages/MyAffiliatedTransferView.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/incoming/:id([0-9]+)",
        props: true,
        name: "view-incoming-order",
        component: () => import("pages/MyOrderIncomingView.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/incoming/:id([0-9]+)/decline",
        props: true,
        name: "decline-incoming-order-items",
        component: () => import("pages/MyOrderIncomingDeclineItems.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders", "edit_order_items"],
        },
      },
      {
        path: "my/orders/incoming/manual/:draftId([0-9]+)?",
        props: true,
        name: "manual-incoming-order",
        component: () => import("pages/MyOrderManualAdd.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_incoming_orders"],
        },
      },
      {
        path: "my/orders/outgoing",
        props: true,
        name: "my-outgoing-orders",
        component: () => import("pages/MyOrdersOutgoing.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_outgoing_orders"],
        },
      },
      {
        path: "/my/orders/outgoing/generic-orders",
        props: { sellerView: false },
        name: "outgoing-generic-orders",
        component: () => import("pages/GenericOrdersList.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_outgoing_orders"],
        },
      },
      {
        path: "/my/orders/outgoing/generic-orders/:id([0-9]+)",
        props: (route) => ({ id: route.params.id, sellerView: false }),
        name: "view-outgoing-generic-order",
        component: () => import("pages/GenericOrderDetail.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_outgoing_orders"],
        },
      },
      {
        path: "my/orders/outgoing/:id([0-9]+)",
        props: true,
        name: "view-outgoing-order",
        component: () => import("pages/MyOrderOutgoingView.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
          permissions: ["view_outgoing_orders"],
        },
      },
      {
        path: "my/orders/offers",
        props: true,
        name: "my-pending-offers",
        component: () => import("pages/MyOrdersPendingOffers.vue"),
        meta: {
          hide_top_search: true,
          hide_top_licenses: true,
        },
      },

      // //My Offers Page
      // {
      //   path: "/offers",
      //   props: true,
      //   name: "my-offers",
      //   component: () => import("pages/MyOffers.vue"),
      // },
      // New Stuff
      // System Pages
      //Data Reports
      {
        path: "/data-Analytics",
        props: true,
        name: "data-analytics",
        component: () => import("pages/DataReports.vue"),
      },

      {
        path: "/my/inventory/product-sync",
        props: true,
        name: "externalProductsImport",
        component: () => import("pages/ExternalProductsImport.vue"),
      },

      //Reports.
      {
        path: "/reports/orders-by-date",
        name: "report-orders-by-date",
        component: () => import("pages/reports/OrdersByDate"),
      },
      {
        path: "/reports/products-sold",
        name: "report-products-sold",
        component: () => import("pages/reports/ProductsSold.vue"),
      },
      {
        path: "/reports/reserved-inventory",
        name: "report-reserved-inventory",
        component: () => import("pages/reports/ReservedInventory.vue"),
      },
      {
        path: "/reports/customer-value",
        name: "report-customer-value",
        component: () => import("pages/reports/CustomerValue.vue"),
      },
      {
        path: "/reports/inventory-overview",
        name: "report-inventory-overview",
        component: () => import("pages/reports/InventoryOverview.vue"),
      },
      {
        path: "/reports/aging-receivables",
        name: "report-aging-receivables",
        component: () => import("pages/reports/AgingAR.vue"),
      },
      {
        path: "/reports/samples",
        name: "report-samples",
        component: () => import("pages/reports/Samples.vue"),
      },
      {
        path: "my/company/roles",
        name: "view-company-user-roles",
        redirect: {
          name: "my-company-team-hub",
          query: { tab: "users-permissions" },
        },
      },
      // {
      //   path: "my/company/settings",
      //   name: "my-company-company-settings",
      //   redirect: {
      //     name: "my-company-profile-hub",
      //     query: { tab: "account-settings" },
      //   },
      // },
    ],
  },

  {
    path: "/auth",
    component: () => import("layouts/AuthLayout"),
    meta: {
      auth_page: true,
    },
    children: [
      {
        path: "",
        name: "auth",
        component: () => import("pages/Auth"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "login",
        name: "auth-login",
        component: () => import("pages/AuthLogin"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "cts-login",
        name: "AuthCTSLogin",
        component: () => import("pages/AuthCtsPortalLogin"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "apply",
        name: "auth-apply",
        component: () => import("pages/AuthApplication"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "apply/:token",
        props: true,
        name: "auth-apply-confirm",
        component: () => import("pages/AuthApplication"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "password/forgot",
        name: "auth-forgot-password",
        component: () => import("pages/AuthForgotPassword"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "password/reset/:token",
        props: true,
        name: "auth-reset-password",
        component: () => import("pages/AuthResetPassword"),
        meta: {
          auth_page: true,
        },
      },
      {
        path: "setup/:token",
        props: true,
        name: "auth-setup-account",
        component: () => import("pages/AuthAccountSetup"),
        meta: {
          auth_page: true,
        },
      },
    ],
  },

  //Publicly accessible invoice page
  {
    path: "/invoices/:code",
    name: "public-invoice",
    component: () => import("pages/PublicInvoice"),
    props: true,
    meta: {
      public_page: true,
    },
  },
  // Publicly accessible menu page
  {
    path: "/menu/public/:menuId([0-9]+)/:slug?",
    name: "public-menu",
    component: () => import("pages/PublicCustomMenuPage.vue"),
    props: (route) => ({
      brandId: Number(route.params.menuId),
      slug: route.params.slug || null,
    }),
    meta: {
      public_page: true,
    },
  },
  // Publicly accessible brand page
  {
    path: "/brands/public/:brandId([0-9]+)/:slug?",
    name: "public-brand",
    component: () => import("pages/PublicBrandPage.vue"),
    props: (route) => ({
      brandId: Number(route.params.brandId),
      slug: route.params.slug || null,
      is_company_storefront: false,
    }),
    meta: {
      public_page: true,
    },
  },
  // Publicly accessible company storefront page
  {
    path: "/brands/public/company-:companyId([0-9]+)",
    name: "public-company-storefront",
    component: () => import("pages/PublicBrandPage.vue"),
    props: (route) => ({
      brandId: Number(route.params.companyId),
      is_company_storefront: true,
    }),
    meta: {
      public_page: true,
    },
  },
  {
    path: "/race-charts/:viewName",
    name: "public-race-chart",
    component: () => import("pages/RaceChartPage.vue"),
    props: (route) => ({
      viewName: route.params.viewName,
      publicMode: true,
    }),
    meta: {
      public_page: true,
    },
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    redirect: "/",
  },
];

export default routes;
